<template>
    <div>
        <div :class="['row', '', '', 'col-3']">
            <div :class="['col-md-12']">
                <div class="form-group">
                    <label for="proyecto" :class="['label_required']">Proyecto</label>
                    <select v-model="formData.proyecto" ref="proyecto" class="form-control" >
                        <option v-for="(val, key) in proyectos" :key="key" :value="val.valor">{{val.descripcion}}</option>
                    </select>
                </div>
            </div>
            
            <div :class="['col-md-12']">
                <div class="form-group">
                    <label for="anio" :class="['label_required']">Año</label>
                    <select v-model="formData.anio" ref="anio" class="form-control" >
                        <option v-for="(val, key) in Anio" :key="key" :value="val" >{{val}}</option>
                    </select>
                </div>
            </div>

            <div :class="['col-md-12']">
                <div class="form-group">
                    <label for="mes" :class="['label_required']">Mes</label>
                    <select v-model="formData.mes" ref="mes" class="form-control" >
                        <option v-for="(val, key) in meses()" :key="key" :value="val.id" >{{val.descripcion.toUpperCase()}}</option>
                    </select>
                </div>
            </div>

            <div :class="['col-md-12']">
                <div class="form-group">
                    <label for="version" :class="['']">Version</label>
                    <select v-model="formData.version" ref="version" class="form-control" >
                        <option value=" ">I</option>
                        <option value="_II">I</option>
                    </select>
                </div>
            </div>

            <div :class="['col-md-12']">
                <div class="form-group">
                    <button type="button" @click="confirmar_identidad" class="btn btn-primary btn-block">Descargar Fideicomiso <i class="fa fa-download"></i></button>
                </div>
            </div>
        </div>


        <Modal ref="form_verificacion" dialog="modal-sm">
			<template slot="title">Confirme su Identidad</template>
			<form :class="['modal-body', 'needs-validation', 'was-validated']" novalidate>
				<div :class="['']">
					<div :class="['row']">
						<div :class="['col-lg-12', 'col-12', 'form-group']">
                            <form class="needs-validation was-validated">
								<div class="form-group">
									<div class="alert alert-info" role="alert">
									  Por favor identifiquese...
									</div>
								</div>
								
								<div class="form-group">
									<label>USUARIO</label>
									<input type="text" placeholder="Ingrese usuario" required="" v-model="formIdentidad.user_fideicomiso" ref="user_fideicomiso" class="form-control">
								</div>
							
								<div class="form-group">
									<label>CLAVE</label>
									<input type="password" placeholder="Ingrese clave" required="" v-model="formIdentidad.clave_fideicomiso" ref="clave_fideicomiso" class="form-control">
								</div>
								
								<div class="form-group dont_access" v-if="!formIdentidad.autorizado && mensaje">
									<div class="alert fade show" :class="[formIdentidad.autorizado?'alert-success':'alert-danger']" role="alert">
										<strong>Hey!</strong> Tu no tienes autorización para acceder a este contenido.
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</form>

			<template slot="footer">
				<button type="button" :class="['btn', 'btn-primary', 'w-auto', 'mr-2', 'h-auto', 'waves-effect', 'waves-themed']" @click="validar_descarga">
					<i class="fa fa-check-circle" aria-hidden="true"></i> Confirmar
				</button>

                <button type="button" :class="['btn', 'btn-dark', 'w-auto', 'mr-2', 'h-auto', 'waves-effect', 'waves-themed']" @click="cerrarModal">
					<i class="icofont-ui-close" ></i> Cerrar
				</button>
			</template>
		</Modal>
    </div>
</template>

<script>
    import {mapState, mapMutations, mapActions} from 'vuex';
    import Modal from '@/components/Modal.vue';

    export default {
        name: 'Fideicomiso',
        components:{
            Modal,
        },
        computed:{
            ...mapState(['loading','globales','empresa']),
        },
        mounted(){
            this.loadObjEmpresa();
            document.title = "Fideicomiso ||"+(this.empresa.abreviatura);
            var today = new Date();
            for(var i = today.getFullYear(); i>=2015; i--){
                this.Anio.push(i);
            }

            this.formData.anio = this.extractDate(this.fecha_actual_es(), 'y');
            this.formData.mes = this.extractDate(this.fecha_actual_es(), 'm');
        },
        data(){
            return{
                proyectos:[
                    {"descripcion":"PIP CAFÉ", valor:"CAFE"},
                    {"descripcion":"PIP CACAO", valor:"CACAO"},
                    {"descripcion":"PIP NARANJA", valor:"NARANJA"},
                    {"descripcion":"PIP MAIZ", valor:"MAIZ"},
                    {"descripcion":"DIA", valor:"DIA"},
                ],
                Anio:[],
                formData:{
                    proyecto:"CACAO",
                    anio:"",
                    mes:"",
                    version:" ",
                },
                formIdentidad:{
                    autorizado:false,
                    user_fideicomiso:"",
                    clave_fideicomiso:"",
                },
                mensaje:"",
            }
        },
        methods:{
            ...mapMutations(['setLoading']),
            ...mapActions(['loadObjEmpresa']),
            confirmar_identidad(){
                var selfs = this;
                if(selfs.formData.proyecto==""){
					this.$refs.proyecto.focus();
					return;
				}
                if(this.formData.anio==""){
					this.$refs.anio.focus();
					return;
				}
                if(this.formData.mes==""){
					this.$refs.mes.focus();
					return;
				}
                if(this.formData.version==""){
					this.$refs.version.focus();
					return;
				}

                this.$refs.form_verificacion.open();
            },
            validar_descarga(){
                var selfs = this;
                if(selfs.formIdentidad.user_fideicomiso==""){
					this.$refs.user_fideicomiso.focus();
					return;
				}
                if(selfs.formIdentidad.clave_fideicomiso==""){
					this.$refs.clave_fideicomiso.focus();
					return;
				}
                
                var formPost = new FormData();

                formPost.append('user_fideicomiso', this.formIdentidad.user_fideicomiso);
                formPost.append('clave_fideicomiso', this.formIdentidad.clave_fideicomiso);
                
                this.setLoading(true);
                this.$http.post('webserviceserver/verificar_identidad_fideicomiso', formPost).then((res)=>{
                    this.formIdentidad.autorizado = res.data.status;
                    this.mensaje = res.data.msg;
                    if(!res.data.status){
                        selfs.alertError(res.data.msg, function(){
							//Callback
						});
                    }else{
                        selfs.confirm(
                            {icon:'info'
                            ,title:"<strong>Hola <u>"+res.data.data+"</u></strong>"
                            ,showCloseButton:true
                            ,showCancelButton: true
                            ,focusConfirm: false
                            ,html:"Estas a un paso de descargar el FIDEICOMISO DEL PROYECTO "+selfs.formData.proyecto+", del "+selfs.formData.mes+"/"+selfs.formData.anio
                            ,confirmButtonText:'<i class="fa fa-thumbs-up"></i> Empezar la descarga...!'
                            ,confirmButtonAriaLabel:"Thumbs up, great!"
                            ,cancelButtonAriaLabel:"A&uacute;n no quiero :)"
                            }
                            ,function(){
                                var url = `${window.baseUrl}webserviceserver/reporte_fideicomiso/${selfs.formData.proyecto}/${selfs.formData.mes}/${selfs.formData.anio}/${selfs.formData.version}/${selfs.formIdentidad.user_fideicomiso}/${selfs.formIdentidad.clave_fideicomiso}`;
                                window.open(url, '_blank');
                                selfs.cerrarModal();
                            }
                        );
                    }
                }).finally(()=>{
                    this.setLoading(false);
                });
            },
            cerrarModal(){
                var selfs = this;
				selfs.$refs.form_verificacion.close();
            },
        },
    }
</script>